import {
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { registerLocaleData } from '@angular/common';
import * as de from '@angular/common/locales/de';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  SideNavOuterToolbarModule,
  SideNavInnerToolbarModule,
  SingleCardModule,
} from './layouts';
import { FooterModule } from './shared/components';
import { ScreenService, AppInfoService } from './shared/services';
import { UnauthenticatedContentModule } from './unauthenticated-content';

import { CoreModule } from './shared/services/core/core.module';
import { APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';

import { NgIconsModule, provideNgIconsConfig } from '@ng-icons/core';
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    UnauthenticatedContentModule,
    CoreModule.forRoot(),
    AppRoutingModule,
  ],
  providers: [
    ScreenService,
    AppInfoService,
    { provide: LOCALE_ID, useValue: 'de-DE' as const },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' as const },
  
    provideNgIconsConfig({
      size: '1.5em',
    }),
    // { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // ErrorDialogService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    registerLocaleData(de.default);
  }
}
